export const painPoints = [
  {
    emoji: '⏰',
    title: 'Your shift ends, your paperwork doesn’t',
    desc: 'Twelve hours on the tier, then another hour writing the incident report while the details fade.',
  },
  {
    emoji: '🧾',
    title: 'Reports come back for “clarification”',
    desc: 'A vague word, a missing time or an opinion instead of a fact, and the report is on your desk again.',
  },
  {
    emoji: '⚖️',
    title: 'Every word can be questioned later',
    desc: 'Use-of-force reports, write-ups and grievance responses get read by supervisors, hearing officers and investigators.',
  },
  {
    emoji: '🤖',
    title: 'You tried AI and it sounded fake',
    desc: 'Generic AI writes like a corporate blog. Without the right instructions, it adds things that never happened.',
  },
];
